<template>
  <div class="import-basic">
    <div class="import-btn">
      <el-button type="primary" :loading="async_importing">批量导入物流信息</el-button>
      <input type="file" accept=".xlsx" :disabled="async_importing" @change="handleFileChangeAsync" />
    </div>

    <el-popover
      placement="top-start"
      width="250"
      trigger="hover">
        <div class="meta-info">
          <p><span>导入提醒：</span> 请使用导出的excel文件，填写快递单号后重新导入即可</p>
        </div>
        <i slot="reference" class="el-icon-info meta-info-icon"></i>
    </el-popover>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class LogisticsImport extends Vue {
    xlsxFile = undefined;
    importing = false;
    async_importing = false;

    async handleFileChangeAsync(e) {
      this.xlsxFile = e.target.files[0];
      if (this.xlsxFile) {
        this.async_importing = true;
        try {
          let form = new FormData();
          form.append('file_message', this.xlsxFile);
          const requestConfig = {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
          await this.$request.post('/orders/import_logistics', form, requestConfig)

          this.$message.success('正在导入中，请稍后查看订单');
        } finally {
          e.target.value = '';
          this.async_importing = false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .import-basic {
    display: flex;
    align-items: center;

    .import-btn {
      position: relative;
      margin-right: 0px;

      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 1;
      }
    }
  }

 .meta-info {
    span {
      font-weight: 800;
    }

    p {
      margin: 0.2em 0;
    }
  }

  .meta-info-icon {
    margin-left: -5px;
    margin-right: 10px;
    margin-bottom: 40px;
    cursor: pointer;
  }
</style>
